import React from 'react'
import { Row, Col } from 'react-styled-flexboxgrid'
import PropTypes from 'prop-types'
import Button from '../Button/Button'
import * as styles from './styles'

const propTypes = {
  smallHeader: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  target: PropTypes.string
}

const defaultProps = {
  target: ''
}

export default function CallToActionBanner(props) {
  const {
    smallHeader, header, buttonTitle, linkText, buttonUrl, linkUrl, target
  } = props
  return (
    <styles.Container>
      <styles.SmallHeader>
        {smallHeader}
      </styles.SmallHeader>

      <Row>
        <Col sm={7} xs={12}>
          <styles.Header>
            {header}
          </styles.Header>
        </Col>

        <styles.CenteredCol sm={5} xs={12}>
          <styles.ButtonContainer>
            <a target={target} rel={target ? 'noopener noreferrer' : ''} href={buttonUrl}>
              <Button size="small">{buttonTitle}</Button>
            </a>
          </styles.ButtonContainer>
          <styles.SmallText>
            or
            {' '}
            <a href={linkUrl}>{linkText}</a>
          </styles.SmallText>
        </styles.CenteredCol>
      </Row>
    </styles.Container>
  )
}

CallToActionBanner.propTypes = propTypes
CallToActionBanner.defaultProps = defaultProps
